import { render, staticRenderFns } from "./FrequencySelector.vue?vue&type=template&id=15ce6b8c&scoped=true&"
import script from "./FrequencySelector.vue?vue&type=script&lang=js&"
export * from "./FrequencySelector.vue?vue&type=script&lang=js&"
import style0 from "./FrequencySelector.vue?vue&type=style&index=0&id=15ce6b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce6b8c",
  null
  
)

/* custom blocks */
import block0 from "./FrequencySelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports